import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export type SearchOption = {
  value: string;
  displayName?: string;
};

const useComboBoxApi = (
  options: Array<SearchOption> | undefined,
  numOptions: number,
  debounceInterval: number,
  minLength: number,
  onSearchChange: (value: string | undefined) => void,
  defaultValue?: string,
  controlledValue?: string,
): {
  value: string;
  setValue: (newValue: string | undefined) => void;
  debounce: (searchValue: string | undefined) => void;
  searchOptions: Array<SearchOption>;
} => {
  const [value, setValue] = useState<string>(controlledValue ?? '');
  const [searchOptions, setSearchOptions] = useState<Array<SearchOption>>(
    defaultValue ? [{ value: defaultValue }] : [],
  );

  const debounce = useDebouncedCallback((searchValue: string | undefined) => {
    if ((searchValue && searchValue?.length >= minLength) || searchValue === '') {
      onSearchChange(searchValue);
    }
  }, debounceInterval);

  useEffect(() => {
    setSearchOptions(options?.slice(0, numOptions) ?? []);
  }, [numOptions, options]);

  return {
    value,
    setValue: (newValue: string | undefined) => setValue(newValue ?? ''),
    debounce,
    searchOptions,
  };
};

export default useComboBoxApi;
